module.exports = __webpack_public_path__ + "media/images/wedding/top/reason3-7138f2fae2ac829c30ab4720907909af.jpg";